export default __webpack_public_path__ + "static/media/rectangles-no-1.9e0644ad.ogg";